import { StyleSheet } from 'react-native';
import { widthPercentageToDP as wp, heightPercentageToDP as hp } from 'react-native-responsive-screen';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  scrollItemsContainer: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
  header: {
    flexDirection: 'row',
    marginBottom: 50,
  },
  headerSmall: {
    flexDirection: 'row',
    padding: 10,
  },
  goBackContainerLarge: {
    alignSelf: 'center',
  },
  goBackContainerSmall: {
    alignSelf: 'center',
    flex: 0.3,
  },
  imageLarge: {
    alignSelf: 'center',
    marginLeft: 35,
    width: 23,
    height: 19,
  },
  imageSmall: {
    alignSelf: 'center',
    marginLeft: 10,
    width: 15,
    height: 12,
  },
  textTitleLarge: {
    flex: 0.2,
    color: '#000000',
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'flex-start',
    fontSize: 22,
    fontWeight: '500',
    lineHeight: 20,
    textAlign: 'left',
  },
  textSmall: {
    flex: 1,
    marginLeft: '3%',
    alignSelf: 'center',
    justifyContent: 'center',
    color: '#001639',
    fontSize: 18,
    fontWeight: '700',
    lineHeight: 20,
    textAlign: 'left',
  },
  upperTextContainerLarge: {
    flexDirection: 'column',
    alignSelf: 'flex-end',
    marginTop: 45,
    flex: 0.25,
  },
  btnContainer: {
    flex: 0.6,
    alignSelf: 'center',
    justifyContent: 'center',
  },
  orderBtnContainer: {
    flex: 1,
    alignSelf: 'center',
    justifyContent: 'center',
  },
  btnTitle: {
    color: '#fff',
    fontWeight: '700',
    fontSize: 13,
    lineHeight: 10,
  },
  btnTitleOrders: {
    color: '#fff',
    fontWeight: '700',
    fontSize: 13,
    lineHeight: 13,
  },
  btn: {
    backgroundColor: '#3ABD62',
    borderRadius: 12,
    alignSelf: 'center',
    width: '50%',
  },
  orderBtnLarge: {
    backgroundColor: '#f3f3f323',
    borderRadius: 12,
    alignSelf: 'center',
    width: '30%',
  },
  orderBtnSmall: {
    backgroundColor: '#f3f3f323',
    borderRadius: 12,
    alignSelf: 'center',
    width: '50%',
  },
  iconLarge: {
    flex: 0.1,
    alignSelf: 'center',
  },
  iconSmall: {
    alignSelf: 'center',
  },
  button: {
    backgroundColor: '#f3f3f3',
    borderRadius: 12,
    marginTop: 20,
  },

  totalContainerLarge: {
    flex: 1,
    height: hp('50%'),
    width: wp('25%'),
    borderRadius: 10,
    flexDirection: 'row',
    alignSelf: 'center',
    marginLeft: '2%',
  },
  totalContainerSmall: {
    height: 100,
    width: '90%',
    borderRadius: 10,
    flexDirection: 'row',
    justifyContent: 'center',
    alignSelf: 'center',
  },
  totalTextContainerAdjustmentsLarge: {
    marginTop: 10,
    marginLeft: 20,
    marginBottom: 30,
  },
  totalTextContainerAdjustmentsSmall: {
    justifyContent: 'center',
    alignSelf: 'center',
    paddingVertical: 30,
  },
  totalTextTitleLarge: {
    marginLeft: 15,
    fontSize: 14,
    fontWeight: '700',
    lineHeight: 20,
    textAlign: 'left',
    marginBottom: 5,
    color: '#FFFFFF',
  },
  totalTextTitleSmall: {
    marginTop: 10,
    fontSize: 14,
    fontWeight: '700',
    lineHeight: 20,
    textAlign: 'center',
    color: '#FFFFFF',
  },
  totalTextBalanceLarge: {
    marginTop: 5,
    fontSize: 36,
    fontWeight: '700',
    lineHeight: 24,
    textAlign: 'left',
    marginBottom: 100,
    color: '#FFFFFF',
  },
  totalTextBalanceSmail: {
    fontSize: 20,
    fontWeight: '700',
    lineHeight: 24,
    textAlign: 'center',
    marginBottom: 10,
    color: '#FFFFFF',
  },
  topRowOnListCommercesLarge: {
    flex: 1,
    flexDirection: 'row',
    alignSelf: 'center',
    alignItems: 'center',
    width: '90%',
    justifyContent: 'space-between',
    height: hp('50%'),
    paddingVertical: 15,
    paddingRight: 24,
    paddingLeft: 99,
    borderRadius: 5,
    marginTop: 30,
    color: '#FFFFFF',
  },
  topRowOnListCommercesSmall: {
    flexDirection: 'row',
    alignSelf: 'center',
    alignItems: 'center',
    width: '90%',
    justifyContent: 'space-between',
    height: 50,
    paddingVertical: 15,
    paddingRight: 10,
    paddingLeft: '6%',
    borderRadius: 5,
    marginTop: 30,
    color: '#FFFFFF',
  },
  topRowText: {
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'left',
    color: '#FFFFFF',
  },
});
